module.exports = __webpack_public_path__ + "img/folder.4461e81d.jpg";